export default __webpack_public_path__ + "static/media/TC_Pen.afeb0dd7.svg";